













































































































































































































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import { AppParam, AppParamsEnum } from "@/shared/models/appParam";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import { Action, Getter } from "vuex-class";
import { Currency } from "@/shared/models/currency";
import DateField from "@/components/misc/DateField.vue";
import { ServiceType } from "@/shared/models/serviceType";
import OfficialRatesOBRules from "./OfficialRatesOBRules.vue";
import OfficialRatesLOSRules from "./OfficialRatesLOSRules.vue";
import OfficialRatesOBAndLOSRules from "./OfficialRatesOBAndLOSRules.vue";
import {
  AccomodationUnitTypeViewModel,
  RatePlanAccUnitType,
} from "@/shared/models/accomodationUnitTypeViewModel";
import { RatePlan } from "@/components/calendar/CalendarTypes";
import { parseStringToDateJS } from "@/shared/dateFormatUtils";
import { ListModel } from "@/shared/models/listModel";
import { enumToArray } from "@/shared/commonFunctions";
import PriceInput from "../../calendar/inputs/PriceInput.vue";
import OfficialRatesFormPrices from "./OfficialRatesFormPrices.vue";
import {
  OfficialRateModel,
  OfficialRateRulesCategoriesViewModel,
  OfficialRateRuleModel,
  OfficialRateRulesGroupingEnum,
} from "./types";
import OfficialRatesArrivalsDepartures from "./OfficialRatesArrivalsDepartures.vue";
import handleBrokenRuleAdapter from "@/shared/handleBrokenRuleAdapter";
import { Notification } from "@/store/modules/notifications";
import * as _ from "lodash";
import { DateTime } from "luxon";

export enum UpdateTypeEnum {
  Restrictions = 1,
  Prices = 2,
  RestrictionsAndPrices = 3,
  None = 4,
}

@Component({
  components: {
    RightDrawer,
    FormDescription,
    DateField,
    OfficialRatesOBRules,
    OfficialRatesLOSRules,
    OfficialRatesOBAndLOSRules,
    PriceInput,
    OfficialRatesFormPrices,
    OfficialRatesArrivalsDepartures,
  },
})
export default class OfficialRatesFormNew extends Vue {
  @Prop({ default: null }) officialRateId!: number | null;
  @Prop({ default: false }) open!: boolean;
  @Prop() callback!: () => any;
  @Prop() accUnitType?: AccomodationUnitTypeViewModel;

  @Getter("appParams/tenantCanEditPAXCategories")
  tenantCanEditPAXCategories?: boolean;
  @Getter("appParams/tenantAutomaticPAXCategoriesAreIndividual")
  tenantAutomaticPAXCategoriesAreIndividual?: boolean;
  @Getter("appParams/tenantCanEditLOSCategories")
  tenantCanEditLOSCategories?: boolean;

  @Getter("appParams/tenantOBRsUseRelativePricing")
  tenantOBRsUseRelativePricing?: boolean;

  get tenantUsesOfficialRateRules() {
    return !this.tenantOBRsUseRelativePricing;
  }

  get showPAXCategories() {
    return (
      this.tenantUsesOfficialRateRules &&
      ((this.tenantCanEditPAXCategories ?? false) ||
        (this.tenantAutomaticPAXCategoriesAreIndividual ?? false))
    );
  }

  get showLOSCategories() {
    return (
      this.tenantUsesOfficialRateRules &&
      (this.tenantCanEditLOSCategories ?? false)
    );
  }

  @Getter("appParams/tenantUsesInputPrice")
  tenantUsesInputPrice?: boolean;

  descriptionTextResource = "OfficialRate.FormInstructions";

  fkey = 0;
  dkey = 0;
  pickerDate = "";

  loading = false;
  saving = false;
  saveDialogOpen = false;
  initialOfficialRate = new OfficialRateModel();
  officialRate = new OfficialRateModel();

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
    }

    await this.loadRatePlans();

    if (fresh && this.officialRateId) {
      this.officialRate = new OfficialRateModel();
      await this.loadOfficialRate();
    } else if (fresh) {
      this.loading = true;
      this.officialRate = new OfficialRateModel();

      // select default currency
      this.officialRate.currencyId =
        this.tenantOfficialRateDefaultCurrencyId ??
        this.formalCurrency?.id ??
        0;

      // select default rate plan
      this.officialRate.ratePlanId =
        this.ratePlansForOfficialRate.length > 0
          ? this.ratePlansForOfficialRate[0].id
          : null;

      // set default date from
      if (this.officialRatesDateFromDefaultsToPlus1Day) {
        await this.axios
          .get<string>(
            `AccomodationUnitTypes/${this.accUnitType?.id}/officialRates/latestDateTo`
          )
          .then((x) => {
            if (x.data) {
              const date = parseStringToDateJS(x.data);
              date.setDate(date.getDate() + 1);
              this.officialRate.dateFrom = date.toISOString().substring(0, 10);
              this.pickerDate = this.officialRate.dateFrom;
            }
          });
      }
    }

    if (fresh) {
      await this.axios
        .get<OfficialRateRulesCategoriesViewModel>(
          `AccomodationUnitTypes/${this.accUnitType?.id}/officialRates/GetOfficialRatesRulesCategories`
        )
        .then((res) => {
          const rules = [] as OfficialRateRuleModel[];

          if (this.tenantUsesOfficialRateRules) {
            res.data.losCategories.forEach((los) => {
              res.data.paxCategories.forEach((pax) => {
                rules.push({
                  minPersons: pax.minPersons,
                  maxPersons: pax.maxPersons,
                  minStay: los.minStay,
                  maxStay: los.maxStay,
                  isDefaultLOSCategory: los.isDefault,
                  isDefaultPAXCategory: pax.isDefault,
                  price: null,
                  inputPrice: null,
                  losInputPriceDifference: los.losInputPriceDifference,
                  losInputPriceDifferenceIsAbsolute:
                    los.losInputPriceDifferenceIsAbsolute,
                  losOutputPriceDifference: los.losOutputPriceDifference,
                  losOutputPriceDifferenceIsAbsolute:
                    los.losOutputPriceDifferenceIsAbsolute,
                  obInputPriceDifference: pax.obInputPriceDifference,
                  obInputPriceDifferenceIsAbsolute:
                    pax.obInputPriceDifferenceIsAbsolute,
                  obOutputPriceDifference: pax.obOutputPriceDifference,
                  obOutputPriceDifferenceIsAbsolute:
                    pax.obOutputPriceDifferenceIsAbsolute,
                  accomodationUnitTypesPAXCategoryId: pax.id,
                  accomodationUnitTypesLOSCategoryId: los.id,
                  uniqueKey: pax.id + "_" + los.id,
                  noSales: false,
                });
              });
            });
          }

          // take prices from existing rules
          rules.forEach((r) => {
            const existing = this.officialRate.officialRateRules.find(
              (x) =>
                x.accomodationUnitTypesPAXCategoryId ==
                  r.accomodationUnitTypesPAXCategoryId &&
                x.accomodationUnitTypesLOSCategoryId ==
                  r.accomodationUnitTypesLOSCategoryId
            );
            if (existing) {
              r.price = existing.price;
              r.inputPrice = existing.inputPrice;
              r.noSales = existing.noSales;
            }
          });

          //prefill dropdown
          if (
            !this.tenantOBRsUseRelativePricing &&
            this.officialRate.ratePlanId
          ) {
            this.officialRate.derivedRatePlanIdsToUpdateRestrictions =
              this.accUnitTypeRatePlans
                .filter(
                  (x) => x.parentRatePlanId === this.officialRate.ratePlanId
                )
                .map((x) => x.ratePlanId);
          }
          if (
            this.tenantOBRsUseRelativePricing &&
            this.officialRate.ratePlanId
          ) {
            this.officialRate.ratePlanIdsToUpdate = [
              this.officialRate.ratePlanId,
            ];
            this.officialRate.derivedRatePlanIdsToUpdateRestrictions =
              this.accUnitTypeRatePlans
                .filter((x) =>
                  this.officialRate.ratePlanIdsToUpdate.includes(
                    x.parentRatePlanId ?? 0
                  )
                )
                .map((x) => x.ratePlanId);
            this.ratePlanIdsToUpdateChanged();
          }
          
          // finish rules setup
          this.officialRate.officialRateRules = _.cloneDeep(rules);
          this.initialOfficialRate = _.cloneDeep(this.officialRate);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  @Action("codebooks/refreshCurrencies")
  refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];

  @Getter("calendar/nonOBRatePlans") nonOBRatePlans?: RatePlan[];
  @Action("calendar/refreshNonOBRatePlans")
  refreshNonOBRatePlans?: () => Promise<void>;

  @Action("codebooks/refreshServiceTypes")
  refreshServiceTypes?: () => Promise<void>;
  @Getter("codebooks/serviceTypes") serviceTypes?: ServiceType[];

  @Getter("appParams/workingCurrency") workingCurrency?: Currency;
  @Getter("appParams/formalCurrency") formalCurrency?: Currency;
  @Getter("appParams/allow0InputPriceForOfficialRate") allow0InputPriceForOfficialRate?: boolean
  @Getter("appParams/appParams") appParams?: AppParam[];
  @Getter("appParams/officialRatesDateFromDefaultsToPlus1Day")
  officialRatesDateFromDefaultsToPlus1Day?: boolean;

  @Getter("appParams/tenantOfficialRateDefaultCurrencyId")
  tenantOfficialRateDefaultCurrencyId?: number;
  @Getter("appParams/allowOfficialRatesInWorkingCurrency")
  allowOfficialRatesInWorkingCurrency?: boolean;
  @Getter("appParams/officialRatesUseSeasonNames")
  officialRatesUseSeasonNames?: boolean;

  get tenantUsesServiceType() {
    const param = this.appParams?.find(
      (x) => x.id == AppParamsEnum.ReservationTenantUsesServiceTypes
    );
    return param && param.value;
  }

  @Watch("officialRate.ratePlanId")
  officialRatePlanChanged() {
    this.officialRate.derivedRatePlanIdsToUpdateRestrictions = [];
  }

  get currencyItems() {
    return [
      {
        id: this.formalCurrency?.id,
        text: this.formalCurrency?.isoCode,
      },
      ...(this.allowOfficialRatesInWorkingCurrency
        ? [
            {
              id: this.workingCurrency?.id,
              text: this.workingCurrency?.isoCode,
            },
          ]
        : []),
    ];
  }

  currencyIsoCode(currencyId: number) {
    if (this.currencies) {
      return this.currencies.find((x) => x.id == currencyId)?.isoCode ?? "";
    }

    return "";
  }

  get ratePlanSelectDisabled() {
    return this.ratePlansForOfficialRate.length === 1 || !!this.officialRate.id;
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      validPeriod: () =>
        this.periodValid() ||
            this.$t("OfficialRates.DateFromCantBeGreaterThanDateTo"),
      };
  }

  periodValid() {
    const period = [this.officialRate.dateFrom, this.officialRate.dateTo];

    if (period[0] === "" || period[1] === "") {
      return true;
    }

    return period[0] <= period[1];
  }

  async created() {
    const promises = [];

    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      promises.push(this.refreshCurrencies());
    }

    if ((this.serviceTypes?.length ?? 0) === 0 && this.refreshServiceTypes) {
      promises.push(this.refreshServiceTypes());
    }

    if (
      (this.nonOBRatePlans?.length ?? 0) === 0 &&
      this.refreshNonOBRatePlans
    ) {
      promises.push(this.refreshNonOBRatePlans());
    }

    await Promise.all(promises);
  }

  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  @Ref("drawer") rightDrawer?: RightDrawer;

  close() {
    this.rightDrawer?.clickOverlay();
  }

  async loadOfficialRate() {
    this.loading = true;
    await Vue.axios
      .get<OfficialRateModel>(
        `AccomodationUnitTypes/${this.accUnitType?.id}/officialRates/${this.officialRateId}`
      )
      .then((res) => {
        this.officialRate = res.data;
        this.officialRate.ratePlanIdsToUpdate = [] as number[];

        this.initialOfficialRate = _.cloneDeep(this.officialRate);
      });
  }

  accUnitTypeRatePlans = [] as RatePlanAccUnitType[];

  get ratePlansForUpdate() {
    if (!this.nonOBRatePlans || !this.accUnitTypeRatePlans) return [];

    return this.nonOBRatePlans.filter(
      (x) =>
        !x.isDerived &&
        this.accUnitTypeRatePlans.map((utr) => utr.ratePlanId).includes(x.id)
    );
  }

  derivedRatePlansFromSelected = [] as RatePlanAccUnitType[];

  ratePlanIdsToUpdateChanged() {
    if (this.officialRate.ratePlanIdsToUpdate.length === 0) {
      this.derivedRatePlansFromSelected = [];
      this.officialRate.derivedRatePlanIdsToUpdateRestrictions = [];
      return;
    }
    this.derivedRatePlansFromSelected = this.accUnitTypeRatePlans.filter((x) =>
      this.officialRate.ratePlanIdsToUpdate.includes(x.parentRatePlanId ?? 0)
    );
    //also unselect derived for unselected standard
    this.officialRate.derivedRatePlanIdsToUpdateRestrictions =
      this.officialRate.derivedRatePlanIdsToUpdateRestrictions.filter((x) =>
        this.derivedRatePlansFromSelected.map((r) => r.ratePlanId).includes(x)
      );
  }

  get derivedRatePlansForRestrictionUpdate() {
    if (
      (!this.nonOBRatePlans || !this.accUnitTypeRatePlans) &&
      !this.officialRate.ratePlanId
    )
      return [];

    return this.accUnitTypeRatePlans.filter(
      (x) => x.parentRatePlanId === this.officialRate.ratePlanId
    );
  }

  get ratePlansForOfficialRate() {
    return this.ratePlansForUpdate.filter((x) => !x.isSpecialOrPackageOffer).sort((a, b) => a.id - b.id);
  }

  async loadRatePlans() {
    await this.axios
      .get<ListModel<RatePlanAccUnitType>>(
        `/AccomodationUnitTypes/${this.accUnitType?.id}/ratePlans`
      )
      .then((res) => {
        this.accUnitTypeRatePlans = res.data.result;
      })
      .finally(() => {
        this.loading = false;
        this.saving = false;
      });
  }

  enumToArray = enumToArray;
  updateTypeEnum = UpdateTypeEnum;
  updateType: UpdateTypeEnum | null = null;
  officialRateRulesGroupingEnum = OfficialRateRulesGroupingEnum;

  grouping = OfficialRateRulesGroupingEnum.ByLengthOfStay;
  toggleExpandCollapse() {
    if (this.$refs.OBAndLOSRules) {
      (
        this.$refs.OBAndLOSRules as OfficialRatesOBAndLOSRules
      ).toggleExpandCollapse();
    }
  }

  maxLength(max: number) {
    return (v: string) =>
      !v || v.length <= max
        ? true
        : this.$t("Validation.MaxLength", { count: max });
  }

  automaticFillingOfPrices() {
    const rules = this.officialRate.officialRateRules.sort((a, b) => {
      if (this.grouping === OfficialRateRulesGroupingEnum.ByLengthOfStay){
        if (a.minStay !== b.minStay) {
          return (a.minStay ?? 0) - (b.minStay ?? 0);
        }
        return (a.minPersons ?? 0) - (b.minPersons ?? 0);
      }
      else {
        if (a.minPersons !== b.minPersons) {
          return (a.minPersons ?? 0) - (b.minPersons ?? 0);
        }
        return (a.minStay ?? 0) - (b.minStay ?? 0);
      }
    });

    for (let i = 0; i < rules.length; i++) {
      if (!rules[i].price) {
        for (let j = i + 1; j < rules.length; j++) {
          if (rules[j].price) {
            rules[i].price = rules[j].price;
            break;
          }
        }
      }
      if (this.tenantUsesInputPrice && !rules[i].inputPrice) {
        for (let j = i + 1; j < rules.length; j++) {
          if (rules[j].inputPrice || (this.allow0InputPriceForOfficialRate && rules[j].inputPrice === 0)) {
            rules[i].inputPrice = rules[j].inputPrice;
            break;
          }
        }
      }
    }
    if (!this.officialRate.officialRateRules.every(
      (x) => x.price && (this.tenantUsesInputPrice ? (x.inputPrice || (this.allow0InputPriceForOfficialRate && x.inputPrice === 0)) : true)))
    {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t("OfficialRates.PricesAreStillMissingAfterAutoCalculation"),
        actions: [
          {
            text: this.$t("Close"),
            fun: () => {
              return true;
            },
          },
        ],
        timeout: 30000,
      } as Notification);
    }
    else {
      this.save();
    }
  }

  save() {
    const pricesAreFilled = this.officialRate.officialRateRules.every((x) => {
      /** to cover some specific cases, we need to allow 0 as a valid input price 
       * @see https://dev.azure.com/infranet/Development/_workitems/edit/14090
      */
      const hasValidInputPrice = this.allow0InputPriceForOfficialRate
        ? (x.inputPrice || x.inputPrice == 0)
        : x.inputPrice

      return x.price &&
        (this.tenantUsesInputPrice 
          ? hasValidInputPrice
          : true)
    });

    if (!pricesAreFilled)
    {
      this.$store.dispatch("showNotification", {
        color: "warning",
        message: this.$t("OfficialRates.EmptyPricesWarning"),
        actions: [
          {
            text: this.$t("OfficialRates.AutomaticallyFill"),
            fun: () => {
              this.automaticFillingOfPrices();
              return true;
            },
          },
          {
            text: this.$t("OfficialRates.ManuallyFill"),
            fun: () => {
              return true;
            },
          },
        ],
        timeout: 30000,
      } as Notification);
    }
    else if (
      this.tenantUsesOfficialRateRules &&
      this.showPAXCategories &&
      this.showLOSCategories
    ) {
      this.updateType = UpdateTypeEnum.RestrictionsAndPrices;
      this.submit();
    } else if (this.showPAXCategories || this.showLOSCategories || this.officialRate.ratePlanIdsToUpdate.length > 0) {
      this.updateType = null;
      this.dkey++;
      this.saveDialogOpen = true;
    } else {
      this.updateType = null;
      this.submit();
    }
  }

  currentDatetime = DateTime.now();

  submit(overrides: string[] = []) {
    this.form.validate();

    if (!this.isFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    //submit
    this.saving = true;
    if (this.officialRate.id && this.officialRate.id !== 0) {
      const handleCodes = ["RatePlan.DeleteValidation.OtaSync"];
      const adapter = handleBrokenRuleAdapter(this.axios, handleCodes);

      // prettier-ignore
      const formatBrokenRuleNames = (x: string[]) => x
      .map((h) => this.$t(h).toString())
      .map((th) => th.endsWith(".") ? th : th + ".")
      .join(" ");

      const isOverriding = overrides.length !== 0;
    
      Vue.axios
        .put(
          `AccomodationUnitTypes/${this.accUnitType?.id}/officialRates/${this.officialRate.id}`,
          {
            ...this.officialRate,
            ratePlanId: !this.tenantOBRsUseRelativePricing ? this.officialRate.ratePlanId : null,
            updatePrices:
              this.updateType == UpdateTypeEnum.Prices ||
              this.updateType == UpdateTypeEnum.RestrictionsAndPrices,
            updateRestrictions:
              this.updateType == UpdateTypeEnum.Restrictions ||
              this.updateType == UpdateTypeEnum.RestrictionsAndPrices,
            overrideRules: overrides,
            requestedAt: this.currentDatetime
          },
          {
            adapter: isOverriding ? undefined : adapter,
          }
        )
        .then((res) => {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("OfficialRates.SuccessSave"),
            timeout: 5000,
          });

          if (res.data.asyncUpdateStarted) {
            this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("Async calendar update started"),
            timeout: 10000,
            });
          }

          this.$emit("update:open", false);

          this.$store.dispatch("calendar/refreshRatePlans", undefined, {
            root: true,
          });

          this.callback();
        })
        .catch((x) => {
          if (x && x.isHandleBrokenRuleResult && !isOverriding) {
            this.$store.dispatch("showNotification", {
              color: "warning",
              message:
                // prettier-ignore
                `${formatBrokenRuleNames(x.handled)} ${this.$t("Do you wish to continue anyway?")}`,
              timeout: 30000,
              actions: [
                {
                  text: this.$t("Yes"),
                  fun: () => {
                    this.submit(x.handled);
                    return true;
                  },
                },
                { text: this.$t("Cancel"), fun: () => true },
              ],
            } as Notification);
          } else {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: `${formatBrokenRuleNames(x.unhandled)}`,
              timeout: 5000,
            } as Notification);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    } else {
      Vue.axios
        .post(`AccomodationUnitTypes/${this.accUnitType?.id}/officialRates`, {
          ...this.officialRate,
          ratePlanId: !this.tenantOBRsUseRelativePricing ? this.officialRate.ratePlanId : null,
          updatePrices:
            this.updateType == UpdateTypeEnum.Prices ||
            this.updateType == UpdateTypeEnum.RestrictionsAndPrices,
          updateRestrictions:
            this.updateType == UpdateTypeEnum.Restrictions ||
            this.updateType == UpdateTypeEnum.RestrictionsAndPrices,
          requestedAt: this.currentDatetime
        })
        .then((res) => {
          this.officialRate = {
            ...this.officialRate,
            id: res.data.officialRateId,
          };

          this.initialOfficialRate = _.cloneDeep(this.officialRate);

          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("OfficialRates.SuccessSave"),
            timeout: 5000,
          });

          if (res.data.asyncUpdateStarted) {
            this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("Async calendar update started"),
            timeout: 10000,
            });
          }

          this.$emit("update:open", false);

          this.$store.dispatch("calendar/refreshRatePlans", undefined, {
            root: true,
          });

          this.callback();
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
}
